var _circle, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCloseDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#0E4C54"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.14258,
    y: 13,
    width: 1.61649,
    height: 9.69895,
    rx: 0.808246,
    transform: "rotate(-135 6.14258 13)",
    fill: "#FFF496"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6.14453,
    width: 1.61649,
    height: 9.69895,
    rx: 0.808246,
    transform: "rotate(-45 5 6.14453)",
    fill: "#FFF496"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseDark);
export default __webpack_public_path__ + "static/media/icon-close-dark.d03bd6559b3559154193f0ddec37c096.svg";
export { ForwardRef as ReactComponent };